import styled from 'styled-components';

const Container = styled.div``;

const MessageStats = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

const StatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
  ${({ theme }) => theme.fontSize.M14}
  color: ${({ theme }) => theme.colors.GREY_DARK};
`;

const AdStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.S8};
`;

export { Container, MessageStats, StatsRow, AdStats };
